<template>
    <div>

        <!-- Cards -->
        <b-row class="font-weight-bold w-full w-100 m-auto shadow-sm ms:p-0 ms:px-4 py-2" cols-sm="12" cols-md="2" cols-lg="2" cols-xl="3">
            <b-col class="mb-2">
                <div class="content-card-info">
                    <div>
                        <i class="fa fa-check" />
                        <span>Total histórico RPQ</span>
                    </div>
                    <h1>{{ selectedResumenRpq.verificados }}</h1>
                </div>
            </b-col>
            <b-col class="mb-2">
                <el-tooltip  class="item" effect="dark" placement="top-start">
                    <div slot="content">
                        <h6>Inventario actual.</h6>
                    </div>
                    <div class="content-card-info">
                        <div>
                            <i class="fa nav-icon icon-layers" />
                            <span>Asignado RPQ</span>
                        </div>
                        <h1>{{ selectedResumenRpq.asignados }}</h1>
                    </div>
                </el-tooltip>
            </b-col>
            <b-col class="mb-2">
                <el-tooltip  class="item" effect="dark" placement="top-start">
                    <div slot="content">
                        <h6>Visibles por el cliente.</h6>
                        <h6> Caracterización pagada.</h6>
                    </div>
                    <div class="content-card-info">
                        <div>
                            <i class="fa fa-money" />
                            <span>Caracterizado</span>
                        </div>
                        <h1> {{ selectedResumenRpq.pagos }}</h1>
                    </div>
                </el-tooltip>
            </b-col>
            <b-col class="mb-2">
                <div class="content-card-info">
                    <div>
                        <i class="fa fa fa-address-card-o" />
                        <span>TE generadas</span>
                    </div>
                    <h1>{{ selectedResumenRpq.te_gen }}</h1>
                </div>
            </b-col>
            <b-col class="mb-2">
                <div class="content-card-info">
                    <div>
                        <i class="fa fa-file-o" />
                        <span>TE adjunto</span>
                    </div>
                    <h1>{{ selectedResumenRpq.te_adj }}</h1>
                </div>
            </b-col>
          <b-col class="mb-2">
            <div class="content-card-info">
              <div>
                <i class="fa fa-file-o" />
                <span>Disponible en el inventario</span>
              </div>
              <h1>{{ selectedResumenRpq.uso }}</h1>
            </div>
          </b-col>
          <b-col class="mb-2">
            <div class="content-card-info">
              <div>
                <i class="fa fa-file-o" />
                <span>No disponible en el inventario</span>
              </div>
              <h1>{{ selectedResumenRpq.desuso }}</h1>
            </div>
          </b-col>
          <b-col class="mb-2">
            <div class="content-card-info">
              <div>
                <i class="fa fa-file-o" />
                <span>Aprobados</span>
              </div>
              <h1>{{ selectedResumenRpq.aprobados }}</h1>
            </div>
          </b-col>
        </b-row>

        <!-- Buscador de productos (historico) -->
        <BuscaProductos></BuscaProductos>
    </div>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex';

import BuscaProductos from './BuscadorProductos';

export default {
    name: 'empresa-rpq-resasignacionmen',
    components: {
        BuscaProductos,
    },
    async mounted() {
        let emp = await this.obtieneEmpresa();
        await this.asignaEmpresa(emp);
        await this.getProductsIndexRpq();
        await this.listarUbicacionesEmpresa();
        await this.getProductSumByStatus(this.$route.params.id);
        await this.cantidadSumaRpq(this.$route.params.id);
        await this.getTipo();
    },
    computed: {
        ...mapState('empresa', [
            'selectedAsignacionRpq',
            'selectedResumenRpq'
        ]),
        ...mapState('adjuntos', ['totalTe']),
    },
    methods: {
        ...mapActions('adjuntos', ['getTipo']),
        ...mapActions('empresa', [
            'sumarCantidadRpq',
            'obtieneEmpresa',
            'listarUbicacionesEmpresa',
            'cantidadSumaRpq',
            'getProductSumByStatus'
        ]),
        ...mapActions('productos_emp', [
            'getProductsIndexRpq'
        ]),
        ...mapActions('adjuntos', ['getTotalAttachmentsTECompany']),
        ...mapMutations('productos_emp', [
            'asignaEmpresa'
        ])
    },
};
</script>

<style scoped>
.content-card-info {
    box-shadow: 0 3px 20px -7px #a1a1a1;
    padding: 10px 0 10px 10px;
    border-radius: 10px;
    position: relative;
    width: 100%;
    background: white;
    height: 100px;
    max-height: 89px;
    min-width: 180px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.content-card-info i {
    font-size: 25px;
}

.content-card-info span {
    font-size: 14px;
    display: block;
    font-weight: bold;
    margin-top: 15px;
}

.content-card-info h1 {
    background: #097B83;
    height: 89px;
    margin: 0;
    width: 96px;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    font-size: 19px;
}

@media screen and (max-width: 1963px) {
  .content-card-info {
    min-width: 260px;
  }
}

</style>
